var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-768dc",
    "aria-label": "payments",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6895 9.64321C13.9912 10.9448 13.9912 13.0552 12.6895 14.3568C11.3879 15.6584 9.27758 15.6584 7.97597 14.3568C6.67435 13.0552 6.67435 10.9448 7.97597 9.64321C9.27759 8.34159 11.3879 8.34159 12.6895 9.64321 M16.0235 9.64321C17.3251 10.9448 17.3251 13.0552 16.0235 14.3568C14.7219 15.6584 12.6116 15.6584 11.31 14.3568C10.0083 13.0552 10.0083 10.9448 11.31 9.64321C12.6116 8.34159 14.7219 8.34159 16.0235 9.64321 M18.9998 19H4.99976C3.34276 19 1.99976 17.657 1.99976 16V8C1.99976 6.343 3.34276 5 4.99976 5H18.9998C20.6568 5 21.9998 6.343 21.9998 8V16C21.9998 17.657 20.6568 19 18.9998 19Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.e2a3bd387bec06625e0474df7fa9c3be.svg";
export { ForwardRef as ReactComponent };